import { SET_DOMAINS_LIST } from '../../constants/domainsList';

const setDomainsList = (data) => {
	return {
		type: SET_DOMAINS_LIST,
		payload: data
	};
};

export { setDomainsList };
